import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  nm_paroquia: Yup.string()
    .nullable()
    .trim()
    .required("O campo Nome é obrigatório."),
});
